import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "An harmonic wave is propagating in air from right to left and reaches the left boundary you have chosen. Velocity field and pressure field can be visualized with arrows and colors, respectively, or as a graph. The acoustic impedance Z(x)=p(x)/v(x) is shown as a graph presenting its modulus on a logarithmic scale and its phase. See how the minima and maxima positions of Z are depending on the left boundary and on the frequency of the harmonic wave. Look at the correlation between those extrema of Z and the pressure and velocity fields nodes and extrema.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0107/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
